module.exports = "/src/views/player/documets/images/male.png";